import { aiApi } from '@api/ai-axios';
import axios from 'axios';
import {
  EstimationRequest,
  EstimationResponse,
  InsuranceChatRequest,
  InsuranceChatResponse,
  InitializeRequest,
  InitializeResponse,
} from 'src/services/interfaces/ai';
import { Application } from 'src/services/interfaces/application';

export class AIService {
  /**
   * Run underwriting logic and return accepted/rejected result
   */
  static async runEstimation(data: EstimationRequest | Application): Promise<EstimationResponse> {
    try {
      const response = await aiApi.post<EstimationResponse>('/estimation', data);
      return response.data;
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to run estimation';
      throw new Error(errorMessage);
    }
  }

  /**
   * Multi-turn insurance chatbot
   */
  static async sendInsuranceChatMessage(data: InsuranceChatRequest, isPHQEnabled?: boolean): Promise<InsuranceChatResponse> {
    try {
      console.log('[AIService] Making POST request to /insurance_chat');
      const response = await aiApi.post<InsuranceChatResponse>(`/insurance_chat`, {
        ...data,
        context: {
          ...data.context,
          isPHQEnabled: isPHQEnabled || false,
        },
      });
      console.log('[AIService] Response received', response.data);
      return response.data;
    } catch (error: unknown) {
      console.error('[AIService] Error in sendInsuranceChatMessage:', error);
      console.error('[AIService] Error details:', {
        isAxiosError: axios.isAxiosError(error),
        code: axios.isAxiosError(error) ? error.code : undefined,
        message: error instanceof Error ? error.message : String(error),
        response: axios.isAxiosError(error) ? error.response : undefined,
      });
      // Re-throw the original error to preserve error type (axios error)
      if (axios.isAxiosError(error)) {
        throw error;
      }
      const errorMessage = error instanceof Error ? error.message : 'Failed to send message';
      throw new Error(errorMessage);
    }
  }

  /**
   * Initialize chat/session
   */
  static async initialize(data: InitializeRequest): Promise<InitializeResponse> {
    try {
      const response = await aiApi.post<InitializeResponse>('/initialize', data);
      return response.data;
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to initialize session';
      throw new Error(errorMessage);
    }
  }
}
